import { TICKET_STATUS_LABELS, PATROL_STATUS_LABELS, GEOFENCE_TYPE_LABELS } from '@asi/shared';

const STATUS_COLORS: Record<string, string> = {
  // Ticket status
  PENDING: 'bg-yellow-500/20 text-yellow-700 dark:text-yellow-400',
  ASSIGNED: 'bg-blue-500/20 text-blue-700 dark:text-blue-400',
  IN_PROGRESS: 'bg-purple-500/20 text-purple-700 dark:text-purple-400',
  RESOLVED: 'bg-green-500/20 text-green-700 dark:text-green-400',
  CLOSED: 'bg-gray-500/20 text-gray-600 dark:text-gray-400',
  ESCALATED: 'bg-red-500/20 text-red-700 dark:text-red-400',
  CANCELLED: 'bg-gray-500/20 text-gray-500',
  // Priority
  CRITICAL: 'bg-red-600/20 text-red-700 dark:text-red-400',
  HIGH: 'bg-orange-500/20 text-orange-700 dark:text-orange-400',
  MEDIUM: 'bg-yellow-500/20 text-yellow-700 dark:text-yellow-400',
  LOW: 'bg-gray-500/20 text-gray-600 dark:text-gray-400',
  // Patrol
  AVAILABLE: 'bg-green-500/20 text-green-700 dark:text-green-400',
  EN_ROUTE: 'bg-orange-500/20 text-orange-700 dark:text-orange-400',
  ON_SCENE: 'bg-cyan-500/20 text-cyan-700 dark:text-cyan-400',
  OFF_DUTY: 'bg-gray-500/20 text-gray-600 dark:text-gray-400',
  OFFLINE: 'bg-gray-500/20 text-gray-500',
  // Camera
  ONLINE: 'bg-green-500/20 text-green-700 dark:text-green-400',
  ERROR: 'bg-red-500/20 text-red-700 dark:text-red-400',
  MAINTENANCE: 'bg-yellow-500/20 text-yellow-700 dark:text-yellow-400',
  // Geofence
  SAFE: 'bg-green-500/20 text-green-700 dark:text-green-400',
  DANGER: 'bg-red-500/20 text-red-700 dark:text-red-400',
  RESTRICTED: 'bg-yellow-500/20 text-yellow-700 dark:text-yellow-400',
  MONITORED: 'bg-blue-500/20 text-blue-700 dark:text-blue-400',
};

const ALL_LABELS: Record<string, string> = {
  ...TICKET_STATUS_LABELS,
  ...PATROL_STATUS_LABELS,
  ...GEOFENCE_TYPE_LABELS,
  CRITICAL: 'Crítica',
  HIGH: 'Alta',
  MEDIUM: 'Media',
  LOW: 'Baja',
  ONLINE: 'En línea',
  OFFLINE: 'Desconectada',
  ERROR: 'Error',
  MAINTENANCE: 'Mantenimiento',
};

interface Props {
  status: string;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'sm' }: Props) {
  const colorClass = STATUS_COLORS[status] ?? 'bg-gray-500/20 text-gray-400';
  const label = ALL_LABELS[status] ?? status;
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${colorClass} ${sizeClass}`}>
      {label}
    </span>
  );
}
